<ng-template>
   <div lcsSingleSelectPanel [visible]="isPanelVisible">
      @if (isIncludeEmptyOption) {
      <lcs-option></lcs-option>
      } @for (prompt of prompts | async; track trackBy(prompt)) { @if (prompt.isReusable || (promptIdsToInclude &&
      promptIdsToInclude?.indexOf(prompt.promptId) !== -1)) {
      <lcs-option [value]="prompt" id="lcs-option-id-{{ prompt.promptId }}">
         {{ prompt.name }}
      </lcs-option>
      } }
   </div>
</ng-template>
